import { toast } from 'react-toastify'
import errorString from './errorString'

export default e => toast.error(errorString(e))
